<template>
    <div>
        <div class="alert alert-white" v-if="showError" >
           <div class="row">
              <div class="hidden-sm col-md-1">
                  <span class="alert-icon-radius">
                      <font-awesome-icon icon="info-circle" class="cirle-orange"></font-awesome-icon>
                  </span>
              </div>
               <div class="col-sm-12 col-md-11" style="padding-left: 10%;">
                   <span class="alert-title"> {{ alertTitle }} </span>
                   <br />
                   <span class="text-silver small"> {{ alertMsg }} </span>
               </div>
           </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
  name: 'AlertMsg',

  data () {
    return {
      showError: false,
      alertTitle: 'Alert title',
      alertMsg: 'Alert messages comes here!'
    }
  },
}
</script>

<style>
    .alert-white {
        width: 25%;
        float: right;
        color: #000;
        background-color: #fff;
        border-color: #ccc;
        clear: both;
    }
    .alert-white svg {
        color:orange;
    }
    .alert-title {
        color:#2e2d2c;
        font-size: .9rem;
    }
    .alert-icon-radius {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        display: block;
        text-align: center;
        line-height: 30px;
        border: 1px solid rgba(235, 161, 52, .5);
        background-color: rgba(235, 161, 52, .2);
    }
</style>